export const capitalizeConverter = (string) => string.charAt(0).toUpperCase() + string.slice(1);
//# sourceMappingURL=capitalize.js.map